export function handleAlert(am, ac, setAlertInfo) {
  setAlertInfo({ amessage: am, acolor: ac, show: true });
  setTimeout(() => {
    setAlertInfo({ amessage: "", acolor: "#ffffff", show: false });
  }, 3000);
}
